import Vue from "vue";
import Router from "vue-router";

const goodslist = r =>
  require.ensure([], () => r(require("@/views/goods/goodslist")), "goodslist");
const index = r =>
  require.ensure([], () => r(require("@/views/index/index")), "index");
const center = r =>
  require.ensure([], () => r(require("@/views/center/center")), "center");
const cart = r =>
  require.ensure([], () => r(require("@/views/cart/cart")), "cart");
const hotellist = r =>
  require.ensure([], () => r(require("@/views/index/hotellist")), "hotellist");
const goodsdetails = r =>
  require.ensure(
    [],
    () => r(require("@/views/goods/goodsdetails")),
    "goodsdetails"
  );
const hoteldetails = r =>
  require.ensure(
    [],
    () => r(require("@/views/index/hoteldetails")),
    "hoteldetails"
  );
const order = r =>
  require.ensure([], () => r(require("@/views/index/order")), "order");
const saleorder = r =>
  require.ensure([], () => r(require("@/views/index/saleorder")), "saleorder");
const city = r =>
  require.ensure([], () => r(require("../components/city")), "city");
const hotelorderlist = r =>
  require.ensure(
    [],
    () => r(require("@/views/center/hotelorderlist")),
    "hotelorderlist"
  );
const goodsorderlist = r =>
  require.ensure(
    [],
    () => r(require("@/views/center/goodsorderlist")),
    "goodsorderlist"
  );
const address = r =>
  require.ensure([], () => r(require("@/views/address/address")), "address");
const invoice = r =>
  require.ensure([], () => r(require("@/views/invoice/invoice")), "invoice");
const invoiceinfo = r =>
  require.ensure(
    [],
    () => r(require("@/views/invoice/invoiceinfo")),
    "invoiceinfo"
  );
const editorinvoice = r =>
  require.ensure(
    [],
    () => r(require("@/views/invoice/editorinvoice")),
    "editorinvoice"
  );
const orderdetails = r =>
  require.ensure(
    [],
    () => r(require("@/views/center/orderdetails")),
    "orderdetails"
  );
const goodsorder = r =>
  require.ensure(
    [],
    () => r(require("@/views/goods/goodsorder")),
    "goodsorder"
  );
const editoraddress = r =>
  require.ensure(
    [],
    () => r(require("@/views/address/editoraddress")),
    "editorpage"
  );
const addaddress = r =>
  require.ensure([], () => r(require("@/views/address/addaddress")), "addpage");
const login = r =>
  require.ensure([], () => r(require("@/views/login/login")), "login");
  const ybauth_login = r =>
  require.ensure([], () => r(require("@/views/login/ybauth_login")), "ybauth_login");
const feedback = r =>
  require.ensure([], () => r(require("@/views/feedback/feedback")), "feedback");

const calendar = r =>
  require.ensure([], () => r(require("../components/calendar")), "calendar");

const hotelorderdetails = r =>
  require.ensure(
    [],
    () => r(require("@/views/center/hotelorderdetails")),
    "hotelorderdetails"
  );

Vue.use(Router);
export default new Router({
  mode: "history",
  // base:'h5/',
  routes: [
    {
      path: "/",
      name: "index",
      redirect: "index",
      component: index
    },
    {
      path: "/index.html",
      name: "index",
      redirect: "index",
      component: index
    },
    {
      path: "/index/order",
      name: "order",
      meta: {
        title: "确认订单",
        navShow: false
      },
      component: order,
      children: [
        {
          path: "/invoice/invoice",
          name: "invoice",
          meta: {
            title: "发票信息",
            navShow: false
          },
          component: invoice
        }
      ]
    },
    {
      path: "/index/saleorder",
      name: "saleorder",
      meta: {
        title: "确认订单",
        navShow: false,
        keepAlive: true
      },
      component: saleorder,
      children: [
        {
          path: "/invoice/invoice",
          name: "invoice",
          meta: {
            title: "发票信息",
            navShow: false
          },
          component: invoice
        }
      ]
    },
    {
      path: "/index",
      name: "index",
      component: index,
      meta: {
        keepAlive: true
      },
      children: [
        {
          path: "/index/hotellist",
          name: "hotellist",
          meta: {
            title: "酒店列表",
            navShow: false
          },
          component: hotellist
        },
        {
          path: "/index/hoteldetails",
          name: "hoteldetails",
          meta: {
            title: "酒店详情",
            navShow: false
          },
          component: hoteldetails
        },
        {
          path: "/index/city",
          name: "city",
          meta: {
            title: "选择城市",
            navShow: false
          },
          component: city
        },
        {
          path: "/index/calendar",
          name: "calendar",
          meta: {
            navShow: true
          },
          component: calendar
        }
      ]
    },
    {
      path: "/goods",
      name: "goodslist",
      component: goodslist,
      meta: {
        title: "hotel",
        keepAlive: true
      },
      children: [
        {
          path: "/goods/goodsdetails",
          name: "goodsdetails",
          meta: {
            title: "商品详情",
            keepAlive: true,
            navShow: false
          },
          component: goodsdetails
        },
        {
          path: "/goods/goodsorder",
          name: "goodsorder",
          meta: {
            title: "产品订单",
            keepAlive: true,
            navShow: false
          },
          component: goodsorder
        },
        {
          path: "/goods/address",
          name: "address",
          meta: {
            title: "收货地址",
            navShow: false
          },
          component: address
        },
        {
          path: "/goods/editoraddress",
          name: "editoraddress",
          meta: {
            title: "添加收货地址",
            navShow: false
          },
          component: editoraddress
        }
      ]
    },
    {
      path: "/center",
      name: "center",
      component: center,
      meta: {
        keepAlive: true
      },
      children: [
        {
          path: "/center/hotelorderlist",
          name: "hotelorderlist",
          meta: {
            title: "酒店订单",
            navShow: false
          },
          component: hotelorderlist
        },
        {
          path: "/center/hotelorderdetails",
          name: "hotelorderdetails",
          meta: {
            title: "酒店订单",
            navShow: false
          },
          component: hotelorderdetails
        },
        {
          path: "/center/goodsorderlist",
          name: "goodsorderlist",
          meta: {
            title: "商品订单",
            navShow: false
          },
          component: goodsorderlist
        },
        {
          path: "/feedback/feedback",
          name: "feedbackpage",
          meta: {
            title: "意见反馈",
            navShow: false
          },
          component: feedback
        },
        {
          path: "/center/orderdetails",
          name: "orderdetails",
          meta: {
            title: "订单详情",
            navShow: false
          },
          component: orderdetails
        },
        {
          path: "/center/address",
          name: "addresslist",
          meta: {
            title: "收货地址",
            navShow: false
          },
          component: address
        },
        {
          path: "/center/editoraddress",
          name: "editopage",
          meta: {
            title: "添加收货地址",
            navShow: false
          },
          component: editoraddress
        },
        {
          path: "/center/addaddress",
          name: "addpage",
          meta: {
            title: "编辑收货地址",
            navShow: false
          },
          component: addaddress
        },
        {
          path: "/invoice/invoice",
          name: "invoicepage",
          meta: {
            title: "发票信息",
            navShow: false
          },
          component: invoice
        },
        {
          path: "/invoice/invoiceinfo",
          name: "invoiceinfopage",
          meta: {
            title: "发票信息",
            navShow: false
          },
          component: invoiceinfo
        },
        {
          path: "/invoice/editorinvoice",
          name: "editorinvoicepage",
          meta: {
            title: "发票信息",
            navShow: false
          },
          component: editorinvoice
        }
      ]
    },
    {
      path: "/cart",
      name: "cart",
      component: cart,
      children: [
        {
          path: "/goods/goodsorder",
          name: "goodsorderpage",
          meta: {
            title: "商品订单"
          },
          component: goodsorder
        },
        {
          path: "/address/addresslist",
          name: "addresspage",
          meta: {
            title: "收货地址"
          },
          component: address
        },
        {
          path: "/address/editoraddress",
          name: "editoraddresspage",
          meta: {
            title: "添加收货地址"
          },
          component: editoraddress
        }
      ]
    },
    {
      path: "/login",
      name: "loginpage",
      meta: {
        title: "登录",
        navShow: false
      },
      component: login
    },
    {
      path: "/ybauth_login",
      name: "ybauthLoginpage",
      meta: {
        title: "登录",
        navShow: false
      },
      component: ybauth_login
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js